<template>
  <form>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('student')"
            :placeholder="$t('student')"
            url="/student/catalog"
            name_field="name"
            value_field="student_id"
            @selected="set_student"
            ref="student_dropdown"
            :is_multiple="false"
          />
        </div>
      </div>
      <div class="column">
        <div class="column">
          <generic-dropdown
            :title="$t('period')"
            :placeholder="$t('period')"
            url="/student/period/catalog"
            name_field="name"
            value_field="period_id"
            @selected="set_period"
            ref="period_dropdown"
            :is_multiple="false"
          />
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('program')"
            :placeholder="$t('program')"
            url="/student/program/catalog"
            name_field="name"
            value_field="program_id"
            @selected="set_program"
            ref="program_dropdown"
            :is_multiple="false"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('stage')"
            :placeholder="$t('stage')"
            url="/student/stage/catalog"
            name_field="name"
            value_field="stage_id"
            @selected="set_stage"
            ref="stage_dropdown"
            :is_multiple="false"
            :extra_data="{ program_id: meta.program_id }"
          />
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  change_active_tab,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "Existant",
  components: { GenericDropdown },
  data() {
    return {
      meta: {},
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return (
        !v.meta.student_id ||
        !v.meta.stage_id ||
        !v.meta.program_id ||
        !v.meta.period_id
      );
    },
  },
  methods: {
    set_student(student) {
      let v = this;
      if (student) v.meta.student_id = student.student_id;
    },
    set_stage(stage) {
      let v = this;
      if (stage) v.meta.stage_id = stage.stage_id;
    },
    set_program(program) {
      let v = this;
      if (program) v.meta.program_id = program.program_id;
    },
    get_data() {
      let v = this;
      return v.meta;
    },
    set_initial_state() {
      let v = this;
      v.meta = {};
      v.$refs.student_dropdown.clear();
      v.$refs.program_dropdown.clear();
      v.$refs.stage_dropdown.clear();
      v.$refs.period_dropdown.clear();
    },
    set_period(period) {
      let v = this;
      if (period) v.meta.period_id = period.period_id;
    },
  },
  mounted() {},
  watch: {
    is_form_invalid(value) {
      let v = this;
      v.$emit("form-valid", !value);
    },
  },
};
</script>
<style></style>
